import React, { useCallback } from 'react';
import { arrayOf, func, number, shape, string } from 'prop-types';

import { BonusTitle } from '@atlas/components';
import { BonusCard, MoneyValue } from '@atlas/ui';

import { CDN_TYPE_CRM, imageUrlCDN } from 'common/utils';

const propTypes = {
  activateBonus: func.isRequired,
  bonus: shape({
    bonusType: string,
    financeDataList: arrayOf(
      shape({
        currency: string,
        maxBonusAmount: number,
        minDeposit: number,
      }),
    ),
    imageDescription: string,
    imageLink: string,
    name: string,
    wager: number,
  }).isRequired,
  currency: string.isRequired,
};

const BonusCardWrapper = ({ activateBonus, bonus, currency }) => {
  const activateBonusHandler = useCallback(() => {
    activateBonus(bonus);
  }, [bonus, activateBonus]);

  const financeData = bonus.financeDataList?.find(data => data.currency === currency);

  return (
    <BonusCard
      className="registration-bonus-popup__card"
      image={imageUrlCDN(bonus.imageLink, CDN_TYPE_CRM)}
      imageDescription={bonus.imageDescription}
      key={bonus.name}
      maxBonus={<MoneyValue currency={financeData?.currency} value={financeData?.maxBonusAmount} />}
      minDeposit={<MoneyValue currency={financeData?.currency} value={financeData?.minDeposit} />}
      onActivate={activateBonusHandler}
      title={<BonusTitle name={bonus.name} nameHighlighted={bonus.nameHighlighted} />}
      type={bonus.bonusType}
      wager={`${bonus.wager}`}
    />
  );
};

BonusCardWrapper.propTypes = propTypes;

export default BonusCardWrapper;
